import UserEditTabs from './UserEditTabs';

export default UserEditTabs;
